import type { Image, Paragraph, Root, Text } from 'mdast';
import { visit } from 'unist-util-visit';
import type { Plugin } from 'unified';

const isTextNodeWhitespace = (node: Text) => node.value.trim().length === 0;

const cloneImage = (image: Image): Image => {
  const cloned: Image = {
    type: 'image',
    url: image.url,
    title: image.title ?? null,
    alt: image.alt ?? null,
  };

  if (image.data) {
    cloned.data = { ...image.data };
  }

  if (image.position) {
    cloned.position = { ...image.position };
  }

  return cloned;
};

export const remarkUnwrapImages: Plugin<[], Root> = () => tree => {
  visit(tree, 'paragraph', (node, index, parent) => {
    if (!parent || typeof index !== 'number') {
      return;
    }

    const filteredChildren = (node as Paragraph).children.filter(child => {
      if (child.type === 'text') {
        return !isTextNodeWhitespace(child as Text);
      }
      return true;
    });

    if (filteredChildren.length === 0) {
      return;
    }

    const [firstMeaningful, ...rest] = filteredChildren;
    if (firstMeaningful.type !== 'image') {
      return;
    }

    const captionChildren = rest.filter(child => {
      if (child.type === 'text') {
        return !isTextNodeWhitespace(child as Text);
      }
      return true;
    });

    const replacementNodes: Array<Paragraph> = [
      {
        type: 'paragraph',
        children: [cloneImage(firstMeaningful as Image)],
      },
    ];

    if (captionChildren.length > 0) {
      replacementNodes.push({
        type: 'paragraph',
        children: captionChildren.map(child => structuredClone(child)),
      });
    }

    parent.children.splice(index, 1, ...replacementNodes);
  });
};

